import React from 'react';
import {SHARED_FORM_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {
  Atom,
  Plugins,
  withSystem,
  AtomRenderProps,
} from '@packages/systems/wfdl';
import {excludeSearchByDefaultType} from '@packages/systems/search';
import {
  iconName,
  pluginName,
  qualify,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {
  TListOfElement,
  TRecord,
  TText,
  TTypeConstructor,
} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const SearchForm = Atom.createRender(
  ({
    attributes,
    classes,
    data,
    generateAttributes,
    context,
    renderChild,
  }: AtomRenderProps) => {
    const formFormClasses = classes.push('w-form');

    const action = context ? context.get('action') || '/search' : '/search';

    return (
      <form
        {...generateAttributes(attributes, formFormClasses)}
        action={action}
      >
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </form>
    );
  }
);

const config = createDevlinkAtom({
  constraints: {
    descendants: SHARED_FORM_CONSTRAINTS_DESCENDANTS,
  },
  displayName: 'Search',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Search'), iconName('Search')),
  },
  render: SearchForm,
  showEmpty: true,
  fields: {
    attr: withSystem(
      {private: true},
      TRecord({
        action: withSystem({defaultValue: '/search'}, TText),
      })
    ),
    children: TListOfElement,
    search: TRecord({
      exclude: excludeSearchByDefaultType,
      type: withSystem(
        {labelVariant: 'hidden', defaultValue: 'form'},
        TTypeConstructor(
          qualify(pluginName('Search'), typeName('SearchFormType'))
        )
      ),
    }),
  },
});

export default config;
